<template>
  <a
    :href="item.link"
    class="useful__item"
    rel="noopener noreferrer"
    target="_blank"
    :style="{'background-image': `linear-gradient(180deg, rgba(9, 36, 51, 0.7) 0%, rgba(9, 36, 51, 0.4) 100%), url(${itemBackground})`}"
  >
    <span
      class="useful__type"
      v-html="item.type"
    ></span>
    <h3
      class="useful__title"
      v-html="item.title"
    ></h3>
  </a>
</template>

<script>
  export default {
    name: 'UsefulItem',
    props: {
      item: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    computed: {
      itemBackground() {
        return this.item.background_image
          ? this.item.background_image
          : ''
      }
    }
  }
</script>

<style lang="scss">
  .useful__item {
    position: relative;
    display: block;
    width: 100%;
    min-height: 172px;
    padding: 24px;
    color: #FFF;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 8px;
    transition: box-shadow 0.2s;

    @media (max-width: $breakpoint-lg) {
      padding: 16px;
    }

    @media (max-width: $breakpoint-sm) {
      min-height: 128px;
    }

    &:hover {
      box-shadow: inset 0 0 0 1px $secondary;

      .useful__type {
        color: #FFF;
      }
    }

    .useful__grid--centered & {
      max-width: 50%;

      @media (max-width: $breakpoint-md) {
        max-width: 100%;
      }
    }
  }

  .useful__title {
    margin-top: 8px;
    margin-bottom: 0;
    transition: color 0.2s;
  }

  .useful__type {
    display: inline-flex;
    align-items: center;
    padding: 1px 11px;
    font-size: 12px;
    line-height: 16px;
    border: 1px solid rgba(#FFF, 0.3);
    border-radius: 4px;
  }

  .useful__type-icon {
    margin-right: 4px;
  }
</style>
